import { useState, type FormEvent } from "react";

interface LoginPageProps {
  onLogin: (password: string) => Promise<boolean>;
  error: string;
}

export function LoginPage({ onLogin, error }: LoginPageProps) {
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    if (!password.trim() || loading) return;
    setLoading(true);
    await onLogin(password);
    setLoading(false);
  };

  return (
    <>
      <div className="theatre" />
      <div className="screen" style={{ alignItems: "center", justifyContent: "center" }}>
        <form className="login-card" onSubmit={handleSubmit}>
          <h1>PREVIS PRO</h1>
          <p className="subtitle">Authorized Personnel Only</p>

          {error && <p className="login-error">{error}</p>}

          <input
            className="input-field"
            type="password"
            placeholder="Enter password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoFocus
          />

          <button className="btn-gold" type="submit" disabled={loading || !password.trim()}>
            {loading ? "Verifying..." : "Enter"}
          </button>
        </form>

        <div className="screen-corners-bottom" />
      </div>
    </>
  );
}
